import { useState, useEffect } from "react";
import { Routes, Route, Link } from "react-router-dom";
import { toAssetUrl } from "./shared/common";
import AuthWarning from "./shared/AuthWarning";
import Loading from "./shared/Loading";
import MemesIndex from "./views/memes/index"
import MemesSelect from "./views/memes/select"
import MemesNew from "./views/memes/new"
import MemesShow from "./views/memes/show"
import MemesProvider from "./views/memes/context/MemesContext"
import { useUsers } from "./views/users/context/UsersContext";
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faUser,
  faNavicon
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Main() {
  const { user, getUser } = useUsers();
  const [navDisplayClass, setNavDisplayClass] = useState('')

  useEffect(() => { getUser() }, []);

  const ComponentPerUserState = (target_component: any) => {
    if (!user) {
      return <Loading />
    }
    if (Object.keys(user).length === 0 && user.constructor === Object) {
      return <AuthWarning />
    }

    return target_component
  }

  const handleNav = () => {
    navDisplayClass == 'show_nav' ? setNavDisplayClass('') : setNavDisplayClass('show_nav')
  }

  const hideNav = () => {
    setNavDisplayClass('')
  }

  return (
    <div className="App">
      <nav className="transparent">
        <div className="grid-container">
          <Link to="/" id='logo'>
            <img src={toAssetUrl('images/Logo_bg_nc.svg')} />
            <img
              src={toAssetUrl('images/Fun.svg')}
              id="fun-logo"
            />
          </Link>
          <ul className={navDisplayClass}>
            <li><a href={`${process.env.REACT_APP_PURRS_WEBSITE_HOST}/`}>Начало</a></li>
            <li><Link to="/" onClick={() => hideNav()} >Мемета</Link></li>
            <li className="hide-for-small-only"><Link to="/select" className="button no-margin">Създай</Link></li>
            <li className="show-for-small-only"><Link to="/select" onClick={() => hideNav()} >Създай</Link></li>
            { !user || Object.keys(user).length === 0 ? (
                <li><a href={`/users/sign_in?redirect=${window.location.pathname}`}>Вход</a></li>
              ) : (
                <li><a rel="nofollow" href="/dashboard" className="secondary"><FontAwesomeIcon icon={faUser as IconProp}  /> Управление</a></li>
              )
            }
          </ul>
          <button id="toggle-nav" className="primary-font-color" onClick={() => handleNav()}><FontAwesomeIcon icon={faNavicon as IconProp}  /></button>
        </div>
      </nav>
      <MemesProvider>
        <Routes>
          <Route path="/" element={<MemesIndex />} />
          <Route
            path="/select"
            element={ComponentPerUserState(<MemesSelect />)}
          />
          <Route
            path="/new/:kitten_identifier/:photo_id"
            element={ComponentPerUserState(<MemesNew user={user} />)}
          />
          <Route path="/:meme_identifier" element={<MemesShow />} />
        </Routes>
      </MemesProvider>

    </div>
  );
}

export default Main;